<template>
  <footer class="footer">
  </footer>
</template>

<script>
export default {
  name: 'LayoutFooter',
  data() {
    return {
      data: {
      }
    }
  },
  methods: {

  }
}
</script>

<style lang="scss">
.footer {
  margin-top: 20px;
  height: $footer-height;
  text-align: center;
  background: #ffffff;
}
</style>